import { createSlice } from '@reduxjs/toolkit';
import { createFormalQuote } from 'formal_quote/thunks';

const initialState = {
  formData: {
    recipient_name: '',
    company_name: '',
    job_title: '',
    email: '',
    phone_number: '',
    software_type: 'viewmate_essentials',
    looking_for: 'new_license',
    portability_option: 'not_needed',
    delivery_method: 'instant_download',
    billing_address: '',
    billing_city: '',
    billing_country: '',
    billing_state: '',
    billing_country_region: '',
    billing_zip_code: '',
    delivery_address: '',
    delivery_city: '',
    delivery_country: '',
    delivery_state: '',
    delivery_country_region: '',
    delivery_zip_code: '',
    serial_numbers: '',
    number_of_users: '1',
    license_type: 'standalone',
    license_scope: null,
    same_as_billing: true,
  },
  errors: {},
  loading: false,
  error: null,
  alert: null,
  successModal: false,
  recaptchaCompleted: false,
};

export const formalQuoteSlice = createSlice({
  name: 'formalQuote',
  initialState,
  reducers: {
    setFormData: (state, action) => {
      state.formData = { ...state.formData, ...action.payload };
    },
    resetForm: (state) => {
      state.formData = initialState.formData;
      state.errors = {};
    },
    setErrors: (state, action) => {
      state.errors = action.payload;
    },
    clearErrors: (state) => {
      state.errors = {};
    },
    showSuccessModal: (state) => {
      state.successModal = true;
    },
    dismissSuccessModal: (state) => {
      state.successModal = false;
    },
    setRecaptchaCompleted: (state, action) => {
      state.recaptchaCompleted = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(createFormalQuote.pending, (state) => {
        state.loading = true;
      })
      .addCase(createFormalQuote.fulfilled, (state) => {
        state.loading = false;
      })
      .addCase(createFormalQuote.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error?.message;
      });
  },
});

export const {
  setFormData,
  resetForm,
  setErrors,
  clearErrors,
  showSuccessModal,
  dismissSuccessModal,
  setRecaptchaCompleted,
} = formalQuoteSlice.actions;

export default formalQuoteSlice.reducer;
